import angular from 'angular';
import MediaPicker from '../../../cmsCore/MediaModules/MediaPicker/MediaPicker'
export default angular.module('cms.panels.media-picker-demo', [MediaPicker])
    .component('mediaPickerDemoPanel', {
        template: require('./media-picker-demo-panel.html')
    }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Dashboard/mediaPickingDemoPanel/mediaPickerDemoPanel.js